/* TLC × Perfumery Library — search / family-filter / A–Z jump.
   Progressive enhancement: data is server-rendered; JS only filters.
   Works for any .tpl root that contains [data-tpl-search] + .tpl-card. */
(function () {
  function init(root) {
    var search = root.querySelector('[data-tpl-search]');
    var countEl = root.querySelector('[data-tpl-count]');
    var chips = Array.prototype.slice.call(root.querySelectorAll('[data-tpl-cat]'));
    var azBtns = Array.prototype.slice.call(root.querySelectorAll('[data-tpl-letter]'));
    var cards = Array.prototype.slice.call(root.querySelectorAll('.tpl-card'));
    var groups = Array.prototype.slice.call(root.querySelectorAll('.tpl-group'));
    var empty = root.querySelector('[data-tpl-empty]');
    var noun = root.getAttribute('data-noun') || 'entries';
    var cat = '';

    function apply() {
      var q = (search && search.value || '').trim().toLowerCase();
      var shown = 0;
      cards.forEach(function (c) {
        var name = (c.getAttribute('data-name') || '').toLowerCase();
        var fam = (c.getAttribute('data-family') || '').toLowerCase();
        var text = (c.textContent || '').toLowerCase();
        var okCat = !cat || fam.indexOf(cat) > -1;
        var okQ = !q || name.indexOf(q) > -1 || fam.indexOf(q) > -1 || text.indexOf(q) > -1;
        var on = okCat && okQ;
        c.style.display = on ? '' : 'none';
        if (on) shown++;
      });
      // hide empty letter groups
      groups.forEach(function (g) {
        var any = g.querySelectorAll('.tpl-card:not([style*="display: none"])').length;
        g.style.display = any ? '' : 'none';
      });
      if (countEl) countEl.textContent = shown + ' ' + noun;
      if (empty) empty.classList.toggle('is-on', shown === 0);
      // disable a-z buttons whose group is gone
      azBtns.forEach(function (b) {
        var t = root.querySelector('[data-tpl-group="' + b.getAttribute('data-tpl-letter') + '"]');
        b.toggleAttribute('disabled', !t || t.style.display === 'none');
      });
    }

    if (search) search.addEventListener('input', apply);
    chips.forEach(function (ch) {
      ch.addEventListener('click', function () {
        cat = ch.getAttribute('data-tpl-cat') || '';
        chips.forEach(function (x) { x.classList.toggle('is-on', x === ch); });
        apply();
      });
    });
    azBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        var t = root.querySelector('[data-tpl-group="' + b.getAttribute('data-tpl-letter') + '"]');
        if (t) t.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
    apply();
  }
  document.addEventListener('DOMContentLoaded', function () {
    Array.prototype.slice.call(document.querySelectorAll('[data-tpl-root]')).forEach(init);
  });
})();
